<div class="outer">

    <div style="display: flex; justify-content: space-between;margin-bottom: 20px; padding: 20px; background-color: white; border: 1px solid white; border-radius: 10px; font-size: 18px;">
        <div class="fat">{{ 216 | l : lang.ph }}</div>
        <div class="fat">{{ db.productPipeHelper | cartTotal | number : lang.numberFormat : lang.activeLocale }} {{db.configuration.currency}}</div>
    </div>

    <div id="dropin-container"></div>

</div>